import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=5ba5941c&scoped=true&"
import script from "./ShareButtons.vue?vue&type=script&lang=js&"
export * from "./ShareButtons.vue?vue&type=script&lang=js&"
import style0 from "./ShareButtons.vue?vue&type=style&index=0&id=5ba5941c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba5941c",
  null
  
)

export default component.exports